import React, { useState } from 'react';
import { PatientPhotosProps, PatientPhotoType } from '@data/models';
import { Sidebar } from '@view/layouts';
import PatientPhotosFooter from './components/PatientPhotosFooter';
import PatientPhotosHeader from './components/PatientPhotosHeader';
import Photo from './components/Photo';
import ViewportPhoto from './components/ViewportPhoto';
import styles from './styles.scss';

const PatientPhotos = ({
  isOpen,
  onClose,
  photos,
  setIsViewPortPhotoEnabled,
  isViewPortPhotoEnabled,
  colorScheme,
  imageModifications
}: PatientPhotosProps) => {
  const [opacitySliderValue, setOpacitySliderValue] = useState<any>(0.5);
  const [selectedPhoto, setSelectedPhoto] = useState<
    PatientPhotoType | undefined
  >(photos[0]);
  const [viewportKey, setViewportKey] = useState(0);

  const resetViewportPhoto = () => {
    setViewportKey((prevKey) => prevKey + 1);
  };

  const handlePatientPhotosClose = () => {
    onClose();
  };

  const handleRadioChange = () => {
    resetViewportPhoto();
  };

  const handleOpacityChange = (value: number | number[]) => {
    setOpacitySliderValue(value);
  };

  const opacity = 1 - opacitySliderValue;

  return (
    <>
      {isViewPortPhotoEnabled && selectedPhoto?.url && (
        <ViewportPhoto
          key={viewportKey}
          opacity={opacity}
          url={selectedPhoto?.url}
          title={selectedPhoto?.fileKind ?? 'Viewport Photo'}
          onCloseIconClick={() => setIsViewPortPhotoEnabled(false)}
          colorScheme={colorScheme}
          modifications={imageModifications?.find(mod => mod.label === selectedPhoto.fileKind) ?? null}
        />
      )}
      <Sidebar size="sm" isOpen={isOpen}>
        <div className={styles.patientPhotos}>
          <PatientPhotosHeader
            onPatientPhotosClose={handlePatientPhotosClose}
            isViewPortPhotoEnabled={isViewPortPhotoEnabled}
            setIsViewPortModeEnabled={setIsViewPortPhotoEnabled}
          />
          <div className={styles.patientPhotos_photos}>
            {photos?.map((photo) => {
              const modification = imageModifications?.find(mod => mod.label === photo.fileKind);
              return (
                <Photo
                  key={photo.fileKind}
                  fileKind={photo.fileKind}
                  url={photo.url}
                  isViewPortPhotoEnabled={isViewPortPhotoEnabled}
                  selectedPhoto={selectedPhoto}
                  setSelectedPhoto={setSelectedPhoto}
                  onRadioChange={handleRadioChange}
                  modifications={modification}
                />
              );
            })}
          </div>
          {isViewPortPhotoEnabled && (
            <PatientPhotosFooter
              opacityValue={opacitySliderValue}
              onOpacityChange={handleOpacityChange}
            />
          )}
        </div>
      </Sidebar>
    </>
  );
};

export default PatientPhotos;
